import { render, staticRenderFns } from "./ServerBundleDialog.vue?vue&type=template&id=65639ace&scoped=true"
import script from "./ServerBundleDialog.vue?vue&type=script&lang=js"
export * from "./ServerBundleDialog.vue?vue&type=script&lang=js"
import style0 from "./ServerBundleDialog.vue?vue&type=style&index=0&id=65639ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65639ace",
  null
  
)

export default component.exports